export var AgentAccountType;
(function (AgentAccountType) {
    AgentAccountType["EMPEROR"] = "emperor";
    AgentAccountType["BOSS"] = "boss";
    AgentAccountType["MANAGER"] = "manager";
    AgentAccountType["LEADER"] = "leader";
    AgentAccountType["STAFF"] = "staff";
    AgentAccountType["USER"] = "user";
})(AgentAccountType || (AgentAccountType = {}));
//# sourceMappingURL=AgentAccountType.js.map